module.exports = "<nv-react-component component=\"CourseHomeHeader\"></nv-react-component>";